/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StediPayer
 */
export interface StediPayer {
    /**
     * 
     */
    stedi_id: string;
    /**
     * 
     */
    primary_payer_id?: string;
    /**
     * 
     */
    display_name: string;
}

/**
 * Check if a given object implements the StediPayer interface.
 */
export function instanceOfStediPayer(value: object): value is StediPayer {
    if (!('stedi_id' in value) || value['stedi_id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    return true;
}

export function StediPayerFromJSON(json: any): StediPayer {
    return StediPayerFromJSONTyped(json, false);
}

export function StediPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): StediPayer {
    if (json == null) {
        return json;
    }
    return {
        
        'stedi_id': json['stedi_id'],
        'primary_payer_id': json['primary_payer_id'] == null ? undefined : json['primary_payer_id'],
        'display_name': json['display_name'],
    };
}

export function StediPayerToJSON(json: any): StediPayer {
    return StediPayerToJSONTyped(json, false);
}

export function StediPayerToJSONTyped(value?: StediPayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stedi_id': value['stedi_id'],
        'primary_payer_id': value['primary_payer_id'],
        'display_name': value['display_name'],
    };
}

